import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Highlights } from './components/Highlights';
import { Services } from './components/Services';
import { About } from './components/About';
import { Reviews } from './components/Reviews';
import { Faq } from './components/Faq';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-full w-full bg-white font-heading text-slate-900" data-id="element-0" data-mp="2rlf5kqna9k1s">
      <Header data-id="element-1" data-mp="2mmvk0rclqa9y" />
      <main data-id="element-2" data-mp="2mndpmel5m0uj">
        <Hero data-id="element-3" data-mp="2mnnefyugq1yn" />
        <Highlights data-id="element-4" data-mp="2mjznn7gejtnm" />
        <Services data-id="element-5" data-mp="31agput0v2nlk" />
        <About data-id="element-6" data-mp="31ayvgg9eye65" />
        <Reviews data-id="element-7" data-mp="31bianp7oiogh" />
        <Faq data-id="element-8" data-mp="31c1iue7j1yhb" />
        <CTA data-id="element-9" data-mp="31cjo20c63n1d" />
      </main>
      <Footer data-id="element-10" data-mp="2wjgqzi86lvgf" />
    </div>;
}